import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';

import makeStyles from '@mui/styles/makeStyles';
import useWindowSize from '../../lib/utils/Hook/use-window-size';
import PriceCalculator from './Sections/PriceCalculator';
import Memberships from '../../components/Memberships/Memberships';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import PricingCallToAction from './Sections/PricingCallToAction';

const useStyles = makeStyles(() => ({
  memberships: {
    paddingTop: '100px'
  },
  root: {}
}));

export default function PricingPage(props) {
  const [pageOpts] = useState({
    color: 'bg',
    bgColor: 'primary',
    logoColor: 'bg',
    headerColor: 'bg',
    headerBGColor: 'primary'
  });
  const screenSize = useWindowSize();
  const membershipsRef = useRef(null);
  const priceCalculatorRef = useRef(null);
  const classes = useStyles();

  function scrollToSection(hash) {
    let scrollOptions = { behavior: 'smooth', block: 'start' };

    const ref = hash === '#memberships' ? membershipsRef : priceCalculatorRef;

    ref.current.scrollIntoView(scrollOptions);
    props.history.push(`/pricing${hash}`);
  }

  useEffect(() => {
    const { hash } = props.history.location;

    if (hash === '#memberships' || hash === '#price-calculator') {
      scrollToSection(hash);
    }
  }, []);

  return (
    <Grid classes={{ root: classes.root }} container>
      <Header
        color={pageOpts.headerColor}
        bgColor={pageOpts.headerBGColor}
        logoColor={pageOpts.headerLogoColor}
        history={props.history}
        shrink={pageOpts.intersectedMemberships}
        screenSize={screenSize}
        showLogo
      />
      <Grid container classes={{ root: classes.memberships }}>
        <Memberships
          sectionRef={membershipsRef}
          screenSize={screenSize}
          history={props.history}
          isLoggedIn={props.isLoggedIn}
        />
      </Grid>
      <PricingCallToAction history={props.history} />
      <PriceCalculator sectionRef={priceCalculatorRef} />
      <Footer
        screenSize={screenSize}
        history={props.history}
        clearSubscriber={props.clearSubscriber}
        addSubscriber={props.addSubscriber}
        subscriber={props.subscriber}
      />
    </Grid>
  );
}

PricingPage.propTypes = {
  history: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  addSubscriber: PropTypes.func.isRequired,
  clearSubscriber: PropTypes.func.isRequired,
  subscriber: PropTypes.object
};
